exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pointManage{min-height:120vh}.uploadBtn_pM{display:inline-block;width:90px;text-indent:0}.downLoadBtn_pM{position:absolute;right:120px;display:inline-block}.setNecessaryPoint{position:absolute;right:220px}.el-upload__files{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-67a5c657!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/pointManage.vue
// module id = 562
// module chunks = 0